export const AuthRoute = ["login", "signup", "reset-password", "activate-account", "forgot-password" ];
